
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1.971","cy":"1.5","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.971","cy":"6.5","r":"1","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.97 3.036v-.91h8.423v.91H6.97zm0 2.837v-.91h8.423v.91H6.97z","fill":"currentColor"}})])
          )
        }
      }
    